export default __webpack_public_path__ + "d0ba299b8aae7fd384a1618b04378226.svg";